/* Essence Edit — client-side wishlist (localStorage, persists across sessions).
   - Injects a heart into every .ff-product-card (static + dynamically hydrated).
   - Toggles items, reflects active state, keeps a header count.
   - Renders the dedicated /pages/wishlist page from stored items. */
(function () {
  var KEY = 'essence:wishlist:v1';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 5.8a5.1 5.1 0 0 0-7.2 0L12 7.4l-1.6-1.6a5.1 5.1 0 1 0-7.2 7.2L12 21l8.8-8a5.1 5.1 0 0 0 0-7.2Z"></path></svg>';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function add(item) {
    var list = read();
    if (!list.some(function (i) { return i.handle === item.handle; })) { list.unshift(item); write(list); }
  }
  function remove(handle) { write(read().filter(function (i) { return i.handle !== handle; })); }
  function toggle(item) {
    if (has(item.handle)) { remove(item.handle); return false; }
    add(item); return true;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function txt(root, sel) { var e = root.querySelector(sel); return e ? e.textContent.trim() : ''; }
  function inner(root, sel) { var e = root.querySelector(sel); return e ? e.innerHTML.trim() : ''; }

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function cardData(card) {
    var handle = handleFromCard(card);
    var img = card.querySelector('.ff-product-card__media img');
    return {
      handle: handle,
      url: '/products/' + handle,
      title: txt(card, '.ff-product-card__title'),
      vendor: txt(card, '.ff-product-card__vendor'),
      season: txt(card, '.ff-product-card__season'),
      priceHtml: inner(card, '.ff-product-card__price'),
      image: img ? (img.currentSrc || img.getAttribute('src') || '') : '',
      srcset: img ? (img.getAttribute('srcset') || '') : ''
    };
  }

  function injectHearts(scope) {
    var cards = (scope || document).querySelectorAll('.ff-product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('[data-wishlist-heart]')) continue;
      var handle = handleFromCard(card);
      if (!handle) continue; // skip placeholder cards
      var active = has(handle);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ff-product-card__heart' + (active ? ' is-active' : '');
      btn.setAttribute('data-wishlist-heart', '');
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.innerHTML = HEART;
      card.insertBefore(btn, card.firstChild);
    }
  }

  // Item for a heart: cards read from the DOM; PDP/standalone hearts carry data-wishlist-item JSON.
  function itemForHeart(btn) {
    var raw = btn.getAttribute('data-wishlist-item');
    if (raw) { try { return JSON.parse(raw); } catch (e) {} }
    var card = btn.closest('.ff-product-card');
    return card ? cardData(card) : null;
  }
  function handleForHeart(btn) {
    var raw = btn.getAttribute('data-wishlist-item');
    if (raw) { try { return JSON.parse(raw).handle; } catch (e) {} }
    var card = btn.closest('.ff-product-card');
    return card ? handleFromCard(card) : null;
  }

  function refreshHearts() {
    var hearts = document.querySelectorAll('[data-wishlist-heart]');
    for (var i = 0; i < hearts.length; i++) {
      var btn = hearts[i];
      var handle = handleForHeart(btn);
      var active = handle && has(handle);
      btn.classList.toggle('is-active', !!active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    }
    updateCount();
  }

  function updateCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n; els[i].hidden = n === 0; }
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = list.map(function (i) {
      var media = i.image
        ? '<img src="' + esc(i.image) + '"' + (i.srcset ? ' srcset="' + esc(i.srcset) + '"' : '') +
          ' sizes="(max-width: 749px) 58vw, 25vw" loading="lazy" decoding="async" alt="' + esc(i.title) + '">'
        : '<div class="ff-placeholder" aria-hidden="true"></div>';
      return '<article class="ff-product-card">' +
          '<button type="button" class="ff-product-card__heart is-active" data-wishlist-heart aria-pressed="true" aria-label="Remove from wishlist">' + HEART + '</button>' +
          '<a class="ff-product-card__media" href="' + esc(i.url) + '">' + media + '</a>' +
          '<a class="ff-product-card__info" href="' + esc(i.url) + '">' +
            (i.season ? '<span class="ff-product-card__season">' + esc(i.season) + '</span>' : '') +
            (i.vendor ? '<span class="ff-product-card__vendor">' + esc(i.vendor) + '</span>' : '') +
            '<span class="ff-product-card__title">' + esc(i.title) + '</span>' +
            '<span class="ff-product-card__price">' + (i.priceHtml || '') + '</span>' +
          '</a>' +
        '</article>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-heart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var data = itemForHeart(btn);
    if (!data || !data.handle) return;
    var added = toggle(data);
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
  });

  document.addEventListener('wishlist:change', function () { refreshHearts(); renderWishlistPage(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { refreshHearts(); renderWishlistPage(); } });

  function init() {
    injectHearts(document);
    refreshHearts();
    renderWishlistPage();
    updateCount();
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; injectHearts(document); refreshHearts(); });
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
